import { initializeApp } from "firebase/app";
import * as firebase_auth from "firebase/auth";
import * as firebase_firestore from "firebase/firestore";
import * as firebase_storage from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCCxX4y8SwTmRNIJca6ms0v-T7O_FCQm0w",
  authDomain: "delibuddy-84ea8.firebaseapp.com",
  projectId: "delibuddy-84ea8",
  storageBucket: "delibuddy-84ea8.appspot.com",
  messagingSenderId: "834528390191",
  appId: "1:834528390191:web:c7a581a12729adf5182ada",
};


const app = initializeApp(firebaseConfig);

export const auth = firebase_auth.getAuth(app);

export const db = firebase_firestore.getFirestore(app);

export const storage = firebase_storage.getStorage(app);